import type { Kysely} from 'kysely';
import { sql } from 'kysely'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function up(db: Kysely<any>): Promise<void> {
	await db.schema.dropTable('pieces_items_books').ifExists().execute()
	await db.schema.dropTable('pieces_items_films').ifExists().execute()
	await db.schema.dropTable('pieces_items_games').ifExists().execute()
	await db.schema.dropTable('pieces_items_links').ifExists().execute()
	await db.schema.dropTable('pieces_items_texts').ifExists().execute()

	await db.schema
		.createTable('pieces_items')
		.addColumn('id', 'text', (col) => col.primaryKey().notNull())
		.addColumn('date_added', 'datetime', (col) =>
			col.defaultTo(sql`((julianday('now') - 2440587.5)*86400000)`).notNull()
		)
		.addColumn('date_updated', 'datetime')
		.addColumn('slug', 'text', (col) => col.notNull())
		.addColumn('type', 'text', (col) => col.notNull())
		.addColumn('note_markdown', 'text')
		.addColumn('frontmatter_json', 'text')
		.execute()
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function down(db: Kysely<any>): Promise<void> {
	await db.schema.dropTable('pieces_manager').execute()
}
